module.exports = __webpack_public_path__ + "static/media/CartIcon.593576b8.svg";